import type { SiteStaffMember, SiteStaffXatRank } from '@/lib/cms-types';

export const STAFF_XAT_RANK_VOLUNTEER: SiteStaffXatRank = {
  label: 'Volunteer',
  color: '#b688ff',
};

export const STAFF_XAT_RANK_WIKI_EDITOR: SiteStaffXatRank = {
  label: 'Wiki Editor',
  color: '#91b0e2',
};

export const STAFF_XAT_RANK_SMILEY_MAKER: SiteStaffXatRank = {
  label: 'Smiley Maker',
  color: '#dcd358',
};

export const STAFF_XAT_RANK_DEVELOPER: SiteStaffXatRank = {
  label: 'Developer',
  color: '#dc94be',
};

/** Opções editáveis no painel — cargo especial exibido no cartão de /equipe. */
export const STAFF_XAT_RANK_OPTIONS = [
  { id: 'volunteer', rank: STAFF_XAT_RANK_VOLUNTEER },
  { id: 'wiki-editor', rank: STAFF_XAT_RANK_WIKI_EDITOR },
  { id: 'smiley-maker', rank: STAFF_XAT_RANK_SMILEY_MAKER },
  { id: 'developer', rank: STAFF_XAT_RANK_DEVELOPER },
] as const;

export type StaffXatRankOptionId = (typeof STAFF_XAT_RANK_OPTIONS)[number]['id'];

/** Ranks especiais do xat — fallback por username quando não há valor guardado no CMS. */
export const STAFF_XAT_RANK_PRESETS: Record<string, SiteStaffXatRank> = {
  cupim: STAFF_XAT_RANK_VOLUNTEER,
  guinho: STAFF_XAT_RANK_WIKI_EDITOR,
  luig: STAFF_XAT_RANK_SMILEY_MAKER,
  paulo: STAFF_XAT_RANK_DEVELOPER,
};

export function xatRankMatches(a: SiteStaffXatRank, b: SiteStaffXatRank): boolean {
  return (
    a.label.trim().toLowerCase() === b.label.trim().toLowerCase() &&
    a.color.trim().toLowerCase() === b.color.trim().toLowerCase()
  );
}

export function xatRankToOptionId(rank: SiteStaffXatRank | null | undefined): StaffXatRankOptionId | 'none' {
  if (!rank?.label || !rank.color) return 'none';
  const found = STAFF_XAT_RANK_OPTIONS.find((o) => xatRankMatches(o.rank, rank));
  return found?.id ?? 'none';
}

export function optionIdToXatRank(id: string): SiteStaffXatRank | undefined {
  if (!id || id === 'none') return undefined;
  return STAFF_XAT_RANK_OPTIONS.find((o) => o.id === id)?.rank;
}

export function resolveStaffXatRank(member: SiteStaffMember): SiteStaffXatRank | null {
  if (member.xatRank?.label && member.xatRank.color) {
    return member.xatRank;
  }
  const key = String(member.username ?? member.name ?? '')
    .trim()
    .toLowerCase();
  return STAFF_XAT_RANK_PRESETS[key] ?? null;
}

export function resolveStaffXatRankOptionId(member: SiteStaffMember): StaffXatRankOptionId | 'none' {
  return xatRankToOptionId(member.xatRank ?? resolveStaffXatRank(member));
}
